<div class="card flex justify-content-center align-items-center">
  <p>Copyright © logibids 2026</p>
</div>
